<div #gridContent
     (scrolled)="onScroll()"
     *ngIf="iconViewResponse && iconViewResponse.items.length>0"
     [alwaysCallback]="true"
     [infiniteScrollDisabled]="infiniteScrollDisabled"
     [infiniteScrollDistance]="2"
     [infiniteScrollThrottle]="50"
     [scrollWindow]="false" class="grid-content"
     infiniteScroll>
    <mat-grid-list [cols]="columnSize" class="grid" rowHeight="140px">
        <mat-grid-tile attr.data-cy="{{iconResponse.name}}"
                       (click)="onIconViewItemClicked(iconResponse); $event.stopPropagation()"
                       (contextmenu)="checkInside($event, iconResponse);$event.preventDefault()"
                       *ngFor="let iconResponse of iconViewResponse?.items"
                       [matTooltip]="iconResponse.description"
                       [ngClass]="{'selectedItem': iconResponse.isSelected || (selectedItemForComment && selectedItemForComment.itemId === iconResponse.itemId) , 'disabled': (!iconResponse.isSelectable && isDialogView && iconResponse.type === 'File') }"

                       class="flex flex-col justify-start items-center full-grow-no-shrink-no-basis "
                       title="{{iconResponse.isCheckedOut ? 'This file is checked out' : iconResponse.name}}">
            <div
                    class="{{iconResponse.type === 'File' ? 'file' : 'folder'}} flex flex-col justify-center items-center">
        <span (click)="checkInside($event, iconResponse);$event.preventDefault()"
              *ngIf="!isDialogView" class="more-actions-icon">
          <i class="far fa-ellipsis-h" attr.data-cy="ellipsis-{{iconResponse.name}}"></i>
        </span>
                <span
                        *ngIf="(!isDialogView && iconResponse.isSelectable) || (isDialogView && iconResponse.isSelectable && (iconResponse.type === 'File' || (iconResponse.type === 'Folder' && foldersSelectable)))"
                        class="file-selector-checkbox">
          <mat-checkbox (change)="updateSelection(iconResponse);" (click)="this.close();$event.stopPropagation()"
                        [checked]="iconResponse.isSelected">
          </mat-checkbox>
        </span>
                <div (click)="onIconViewItemClicked(iconResponse); $event.stopPropagation()"
                     class="icon-background flex flex-row justify-center items-center">
                    <div *ngIf="!isThumbnailView || !thumbnailViewResponse?.fieldValues[iconResponse.itemId]"
                         [ngClass]="[iconResponse.isHidden?'background-opacity':'', iconResponse.color?iconResponse.color:'']"
                         class="{{iconResponse.icon}}">
                    </div>
                    <div *ngIf="isThumbnailView && thumbnailViewResponse?.fieldValues[iconResponse.itemId]"
                         class='thumbnail-view'>
                        <img src="{{thumbnailViewResponse.fieldValues[iconResponse.itemId]}}" alt="thumbnail-image">
                    </div>
                </div>
                <div class="drive-file-name m-t-15 flex flex-row justify-center items-center">
                    <div class="testy">
                        <!--            <div class="text"-->
                        <!--                 (click)="onIconViewItemClicked(iconResponse); $event.stopPropagation()"-->
                        <!--                 [ngClass]="{checkout: iconResponse.isCheckedOut}"-->
                        <!--                 matTooltip="{{iconResponse.isCheckedOut ? 'This file is checked out' : iconResponse.name}}"-->
                        <!--                 appIconViewNameShortFormat [width]="90">-->
                        <!--              {{iconResponse.name}}-->
                        <!--            </div>-->
                        <!--            <i (click)="markStar(iconResponse);$event.stopPropagation()"-->
                        <!--               *ngIf="iconResponse.parentId !=='trash' && iconResponse.type !== 'SharedDrives' && iconResponse.type !== 'SharedDrive'  && iconResponse.type !== 'PersonalDrive' && !iconResponse.isFavorite"-->
                        <!--               [matTooltip]="'Add to Starred'"-->
                        <!--               class="far fa-star pointer"></i>-->
                        <!--            <i (click)="markStar(iconResponse);$event.stopPropagation()"-->
                        <!--               *ngIf="iconResponse.parentId !=='trash' && iconResponse.type !== 'SharedDrives' && iconResponse.type !== 'SharedDrive'  && iconResponse.type !== 'PersonalDrive'"-->
                        <!--               [matTooltip]="'Remove from Starred'"-->
                        <!--               [ngStyle]="{display:iconResponse.isFavorite? 'inline': 'none' }"-->
                        <!--               class="fas fa-star pointer"></i>-->
                        <div class="text-container">
                            <div class="text"
                                 (click)="onIconViewItemClicked(iconResponse); $event.stopPropagation()"
                                 [ngClass]="{checkout: iconResponse.isCheckedOut}"
                                 appIconViewNameShortFormat [width]="90">
                                {{iconResponse.name}}
                            </div>
                        </div>
                        <span class="stars hide">
                <i (click)="markStar(iconResponse);$event.stopPropagation()"
                   *ngIf="iconResponse.parentId !=='trash' && iconResponse.type !== 'SharedDrives' && iconResponse.type !== 'SharedDrive'  &&    iconResponse.type !== 'PersonalDrive' && !iconResponse.isFavorite"
                   [matTooltip]="'Add to Starred'"
                   class="far fa-star">
                </i>
                <i (click)="markStar(iconResponse);$event.stopPropagation()"
                   *ngIf="iconResponse.parentId !=='trash' && iconResponse.type !== 'SharedDrives' && iconResponse.type !== 'SharedDrive'  && iconResponse.type !== 'PersonalDrive'"
                   [matTooltip]="'Remove from Starred'"
                   [ngClass]="iconResponse.isFavorite? 'visible': 'none' "
                   class="fas fa-star">
                </i>
            </span>

                    </div>

                </div>
            </div>
        </mat-grid-tile>
    </mat-grid-list>
</div>
<ng-template #userMenu let-item>
    <section (contextmenu)="$event.preventDefault();" class="user-menu">
        <div (click)="onMenuAction(action, item);$event.preventDefault()"
             attr.data-cy="item-{{action.title}}"
             *ngFor="let action of getContextMenuActions(item)">
            <span *ngIf="action.title === 'Extract Data'">{{item.dataExtractionStatus}}</span>
            <span *ngIf="action.title !== 'Extract Data'">{{action.title}}</span>
            <i *ngIf="action.title === 'Extract Data'"
               class="{{item.dataExtractionStatus === 'Classifying' ? 'fa-solid fa-sync fa-spin' : 'fa-regular fa-circle-check check-icon' }} m-l-auto"
               attr.data-cy="item-{{action.title}}-status-icon"></i>
        </div>
    </section>
</ng-template>
<app-empty-content
        *ngIf="iconViewResponse && iconViewResponse.items.length<=0"
        [subTitle]="emptyContentSubtitle"
        [title]="emptyContentTitle">
</app-empty-content>
